export default __webpack_public_path__ + "static/media/garrafaTérmica.5d331da3.png";